import { render, staticRenderFns } from "./DesarrolloProfesional.vue?vue&type=template&id=becaf964&scoped=true"
import script from "./DesarrolloProfesional.vue?vue&type=script&lang=js"
export * from "./DesarrolloProfesional.vue?vue&type=script&lang=js"
import style0 from "./DesarrolloProfesional.vue?vue&type=style&index=0&id=becaf964&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "becaf964",
  null
  
)

export default component.exports